module.exports = "../dist/img/mini-31.48fa.jpg";